import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
const PageNav = (props) => {
  const List = styled.li`
    a {
      color: ${window.lrmSettings["primary"]};
    }
    .lrm-reviews-active {
      background: ${window.lrmSettings["primary"]} !important;
      color: #fff;
    }
  `;
  let start = "";
  let end = "";
  let showBeginning = false;
  let showEnd = false;
  let tripleReg = /\d\d/;
  let reg = /\d+/;
  let singleReg = /\d/;
  if (props.page !== 1) {
    if (parseInt(props.page.toString().split("").pop()) === 0) {
      start = props.page - 1;
      end = props.page + 10;
      localStorage.setItem("prevStart", start);
      localStorage.setItem("prevEnd", end);
    }
    if (parseInt(props.page.toString().split("").pop()) !== 0) {
      if (localStorage.getItem("preStart")) {
        start = localStorage.getItem("prevStart");
        end = localStorage.getItem("prevEnd");
      } else {
        let pageNumber = "";
        if (
          parseInt(props.page.toString().match(reg)).toString().length === 3
        ) {
          pageNumber = `${props.page.toString().match(tripleReg)}${0}`;
        } else {
          pageNumber = `${props.page.toString().match(singleReg)}${0}`;
        }
        start = parseInt(pageNumber) - 1;
        end = parseInt(pageNumber) + 10;
      }
    }
  }
  if (props.page < 10) {
    start = 0;
    end = 10;
  }
  if (props.page === Math.floor(props.reviewData.length / 10)) {
    start = Math.floor(props.reviewData.length / 10) - 11;
    end = Math.floor(props.reviewData.length / 10);
  }
  if (props.page !== 1) {
    showBeginning = true;
  }
  if (Math.floor(props.reviewData.length / 10) !== props.page) {
    showEnd = true;
  }
  const scrollUp = () => {
    setTimeout(() => {
      document
        .getElementById("lrmReviews")
        .scrollIntoView({ behavior: "smooth" });
    });
  };
  const resetRoute = () => {
    window.location.replace(window.lrmSettings["review_page"]);
  };
  return (
    <nav key={props.page} className="lrm-reviews-nav">
      <ul className="lrm-reviews-pagination">
        {showBeginning && (
          <List className="lrm-reviews-page-item">
            <Link
              className="lrm-reviews-page-link"
              onClick={() => resetRoute()}
            >
              First
            </Link>
          </List>
        )}
        <List className="lrm-reviews-page-item">
          {props.page !== 1 && (
            <Link
              className="lrm-reviews-page-link"
              to={props.page - 1 === 1 ? "/" : `/page/${props.page - 1}`}
              onClick={() => scrollUp()}
            >
              <i class="fas fa-arrow-left"></i> Previous
            </Link>
          )}
        </List>

        {props.pageCount &&
          props.pageCount.slice(start, end).map((data) => {
            return (
              <List className="lrm-reviews-page-item lrm-reviews-pages">
                <Link
                  className={`lrm-reviews-page-link${
                    props.page === data ? " lrm-reviews-active" : ""
                  }`}
                  to={data === 1 ? "/" : `/page/${data}`}
                  onClick={() => scrollUp()}
                >
                  {data}
                </Link>
              </List>
            );
          })}
        {props.totalPage !== props.page && props.totalPage > 10 && (
          <List className="lrm-reviews-page-item">
            <p className="lrm-reviews-page-link lrm-reviews-disabled">...</p>
          </List>
        )}
        <List className="lrm-reviews-page-item">
          {props.page !== Math.floor(props.reviewData.length / 10) && (
            <Link
              className="lrm-reviews-page-link"
              to={`/page/${props.page + 1}`}
              onClick={() => scrollUp()}
            >
              Next <i class="fas fa-arrow-right"></i>
            </Link>
          )}
        </List>
        {showEnd && (
          <List className="lrm-reviews-page-item">
            <Link
              className="lrm-reviews-page-link"
              to={`/page/${Math.floor(props.reviewData.length / 10)}`}
              onClick={() => scrollUp()}
            >
              Last
            </Link>
          </List>
        )}
      </ul>
    </nav>
  );
};

export default PageNav;
